import {Util} from 'yougile-util'
import {DataObjectId, isDataObjectId} from './data-object'

export interface GoogleCalendarOption {
  id: string
  name: string
  primary: boolean
}

export type GoogleCalendarTasksType = 'all' | 'my'
const googleCalendarIntegrationStatuses = [
  'off',
  'active',
  'isReady',
  'error'
] as const
export type GoogleCalendarIntegrationsStatus =
  (typeof googleCalendarIntegrationStatuses)[number]

export const isGoogleCalendarIntegrationsStatus = (
  status: unknown
): status is GoogleCalendarIntegrationsStatus =>
  typeof status === 'string' &&
  googleCalendarIntegrationStatuses.includes(
    status as GoogleCalendarIntegrationsStatus
  )

export interface CompaniesBoards {
  [key: DataObjectId]: DataObjectId[]
}

export interface GoogleCalendarSettings {
  email: string | undefined
  calendar?: string | undefined
  companiesBoards?: CompaniesBoards
  tasksType?: GoogleCalendarTasksType
}

export interface GoogleCalendarData {
  userId?: DataObjectId
  status?: GoogleCalendarIntegrationsStatus
  settings?: GoogleCalendarSettings
}

export interface UserIntegrations {
  googleCalendar?: {
    [companyId: DataObjectId]: GoogleCalendarData
  }
}

const isGoogleCalendarTasksType = (
  value: any
): value is GoogleCalendarTasksType => {
  return value === 'all' || value === 'my'
}

export const isGoogleCalendarSettings = (
  obj: any
): obj is Required<GoogleCalendarSettings> => {
  const isEmailValid = Util.isEmail(obj.email)
  const isCalendarValid = typeof obj.calendar === 'string'
  const isBoardsValid =
    Array.isArray(obj.boards) && obj.boards.every(isDataObjectId)
  const isTasksTypeValid = isGoogleCalendarTasksType(obj.tasksType)

  return isEmailValid && isCalendarValid && isBoardsValid && isTasksTypeValid
}

export type TwoFactorStep = 'phone' | 'code' | 'blocked' | 'success'

export const storage2FaKeys = {
  step: '2fa:step',
  login: '2fa:login',
  pass: '2fa:pass',
  userId: '2fa:userId',
  authKey: 'authKey',
  codeSentTo: '2fa:codeSentTo',
  retryTimestamp: '2fa:retryTimestamp',
  isPhoneSetByUser: '2fa:isPhoneSetByUser'
} as const
